import { render } from "./VolForm.vue?vue&type=template&id=3430de21&scoped=true"
import script from "./VolForm.vue?vue&type=script&lang=js"
export * from "./VolForm.vue?vue&type=script&lang=js"

import "./VolForm.vue?vue&type=style&index=0&id=3430de21&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3430de21"]])

export default __exports__